import { Cloud, CloudOff, CloudCog } from 'lucide-react';
import {
  CLOUD_POS_STATUS_LABELS,
  CLOUD_POS_STATUSES,
  type CloudPosStatus,
} from '@quds/shared';
import { Badge } from '@/components/ui';

const TONE: Record<CloudPosStatus, 'success' | 'warning' | 'neutral'> = {
  connected: 'success',
  partially_connected: 'warning',
  not_connected: 'neutral',
};

const ICON: Record<CloudPosStatus, typeof Cloud> = {
  connected: Cloud,
  partially_connected: CloudCog,
  not_connected: CloudOff,
};

function safeStatus(status: CloudPosStatus | null | undefined): CloudPosStatus {
  return status && (CLOUD_POS_STATUSES as readonly string[]).includes(status) ? status : 'not_connected';
}

/** Operator-facing Cloud POS channel — never derived from License/Updater links. */
export function CloudPosBadge({
  status,
  className,
}: {
  status?: CloudPosStatus | null;
  className?: string;
}) {
  const resolved = safeStatus(status);
  const Icon = ICON[resolved];
  const label = CLOUD_POS_STATUS_LABELS[resolved];
  return (
    <Badge
      tone={TONE[resolved]}
      title={`Cloud POS: ${label}`}
      icon={<Icon size={12} aria-hidden="true" />}
      className={className}
      dot={resolved === 'connected'}
    >
      Cloud POS: {label}
    </Badge>
  );
}
